import React from "react";
import { D } from "../ui";
import { ArrowUpRight } from "lucide-react";

export function ArrowBtn({ dark }) {
  return (
    <span style={{
      position: "absolute", top: 14, right: 14, width: 30, height: 30, borderRadius: "50%",
      border: `1.5px solid ${dark ? "rgba(255,255,255,0.55)" : "#cfcaba"}`, display: "grid", placeItems: "center",
      color: dark ? "#fff" : D.ink
    }}>
      <ArrowUpRight size={14} />
    </span>
  );
}

export function StatCard({ icon: Icon, label, value, unit, sub, chipText, accent, testid, live, onOpen }) {
  return (
    <div data-testid={testid} onClick={onOpen} style={{
      flex: 1, minWidth: 190, borderRadius: 26, padding: "18px 20px 16px", position: "relative",
      background: accent ? D.blue : D.dark, color: "#fff", cursor: onOpen ? "pointer" : "default",
      boxShadow: "0 12px 26px rgba(20,20,20,0.12)"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 13, fontWeight: 700 }}>
        <Icon size={14} /> {label}
        {live && <span data-testid={`${testid}-live`} title="Diperbarui tiap 10 detik" style={{ display: "inline-flex", alignItems: "center", gap: 5, marginLeft: 4, fontSize: 9.5, letterSpacing: 1.2, fontWeight: 800, opacity: .9 }}><span className="live-dot" style={{ width: 7, height: 7, borderRadius: 99, background: "#4ade80", boxShadow: "0 0 0 0 rgba(74,222,128,.7)" }} />LIVE</span>}
      </div>
      <div style={{ marginTop: 14, fontSize: 30, fontWeight: 800, letterSpacing: -0.8, lineHeight: 1 }}>
        {value} {unit && <span style={{ fontSize: 17, fontWeight: 700 }}>{unit}</span>}
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 10 }}>
        <span style={{ fontSize: 10.5, opacity: 0.72 }}>{sub}</span>
        <span style={{ padding: "3px 10px", borderRadius: 99, fontSize: 11, fontWeight: 800, background: D.chip, color: D.chipInk }}>{chipText}</span>
      </div>
      {onOpen && <ArrowBtn dark />}
    </div>
  );
}
